import { render, staticRenderFns } from "./Mistake.vue?vue&type=template&id=a075f388&scoped=true"
import script from "./Mistake.vue?vue&type=script&lang=js"
export * from "./Mistake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a075f388",
  null
  
)

export default component.exports